var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("欢迎您"+_vm._s(_vm.username)+"进入后台管理系统")])])}
var staticRenderFns = []

export { render, staticRenderFns }